export function addTooltip(element, text, timer = 5000) {
    var body = document.querySelector('body');
    var tooltip = document.createElement('span');
    tooltip.classList.add('tooltip-alert');
    tooltip.setAttribute('role', 'alert');
    tooltip.innerHTML = text;
    body.appendChild(tooltip);
    var left = element.offsetLeft - ((tooltip.clientWidth / 2) - (element.clientWidth / 2) + 2);
    var top = element.offsetTop - (tooltip.clientHeight + 15);
    tooltip.setAttribute('style', 'left:' + left + 'px;top:' + top + 'px;');

    setTimeout(function () {
        tooltip.remove();
    }, timer)
}